import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		safeInfo: {},
		loading: false
	},
	mutations: {
		setSafeInfo(state, safeInfo) {
			state.safeInfo = safeInfo;
		},
		setLoading(state, loading) {
			state.loading = loading;
		}
	}
})

export default store
